import { css, cva } from '@/styled-system/css';

export const overlayRecipe = cva({
  base: {
    position: 'absolute',
    inset: '0',
    zIndex: '1',
  },
  variants: {
    isDisabled: {
      true: { cursor: 'not-allowed' },
      false: { cursor: 'pointer' },
    },
    hasError: {
      true: { backgroundColor: 'rgba(255, 255, 255, 0.5)' },
    },
  },
});

export const iconContainerStyles = css.raw({
  position: 'absolute',
  bottom: '200',
  right: '200',
  zIndex: '2',
});

export const digitallyAlteredBadgeStyles = css.raw({
  position: 'absolute',
  top: '200',
  right: '200',
  zIndex: '2',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '800',
  height: '800',
  borderRadius: 'shape.ellipse',
  backgroundColor: 'bg.screen.neutral',
});

export const backgroundLoadingImageStyles = css.raw({
  height: '100%',
  position: 'absolute',
  width: '100%',
  transition: 'all 0.3s ease-out',
  _loading: {
    color: 'transparent',
    background: '#f1f1f4 linear-gradient(to right, #f1f1f4, #f9f9fb, #f1f1f4) no-repeat 100%',
    opacity: 'inherit',
    animation: 'shimmer 1.5s linear infinite',
  },
  _motionReduce: {
    animation: 'none',
  },
});

export const backgroundImageContainerStyles = css.raw({
  borderRadius: '100',
  // Fills the grid row so a photo matches the upload tiles, whose height follows their label.
  height: '100%',
  minHeight: { base: '90px', lg: '100px' },
  overflow: 'hidden',
  position: 'relative',
  touchAction: 'none',
});
